// extracted by mini-css-extract-plugin
export default {"selection":"ManageSelection_selection__Vm0B3VVb","countSelected":"ManageSelection_countSelected__9QP-5TFG"};